import * as Sentry from "@sentry/react";

import { getConfig } from "./config";

const APP_ENV = getConfig("VITE_APP_ENV");
const SENTRY_DSN = getConfig("VITE_APP_SENTRY_DSN");
const SENTRY_RELEASE = getConfig("VITE_APP_SENTRY_RELEASE");

const isEnabled = SENTRY_DSN && ["production", "staging"].includes(APP_ENV);

const envTracesSampleRateMap = new Map<string, number>([
  ["production", 0.5],
  ["staging", 1],
  ["development", 1],
]);

if (isEnabled) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: envTracesSampleRateMap.get(APP_ENV),
  });
}

export const reportError = isEnabled ? Sentry.captureException : () => null;
export const setSentryUser = isEnabled ? Sentry.setUser : () => null;
